import clsx from 'clsx';
import { Button, Icon, InlineStack, Paragraph, Text } from '@customerio/pluma-components/react';
import { FlexMark, leadingMarkButton } from '@/components/flex-mark';
import type { OlderHistoryNoticeModel } from '../hooks/use-older-history-notice';
import { olderHistoryNoticeText } from '../utils/older-history-notice';
import * as styles from './older-history-notice.css';
import * as addonStyles from './segments-addon-button.css';

type OlderHistoryNoticeProps = OlderHistoryNoticeModel;

/**
 * The strip at the foot of a list's panel, in place of Load more: older history is kept, and the
 * data retention add-on shows it. Render it in a `PanelInset` as the last child of the panel.
 */
export function OlderHistoryNotice({ kind, includedDays, canEditBilling, openAddon }: OlderHistoryNoticeProps) {
  const { title, body } = olderHistoryNoticeText({ includedDays, canEditBilling });

  return (
    <InlineStack
      className={styles.strip}
      gap="150"
      alignBlock="center"
      alignInline="space-between"
      data-test-older-history-notice={kind}
    >
      <InlineStack gap="100" alignBlock="center">
        <Icon name="info" size="sm" color="accent" flexShrink="0" />
        <Paragraph text="product-psm" color="secondary">
          <Text as="span" text="product-psm-active" color="primary">
            {title}
          </Text>{' '}
          {body}
        </Paragraph>
      </InlineStack>
      {canEditBilling ? (
        <Button
          className={clsx(addonStyles.flexTag, leadingMarkButton)}
          size="sm"
          elementBefore={<FlexMark />}
          onClick={openAddon}
        >
          Flex add-on
        </Button>
      ) : null}
    </InlineStack>
  );
}
